import React from 'react'; 
import styled from 'styled-components';


const Styles = styled.div`
.header-line {
    height:50px; 
    background-color:#a6192e;
  }  
  
`;

const Layout = (props) => {

    return (
        <Styles> 
            <div className="fluid header-line animate__animated animate__fadeInDown animate__faster"></div>
            {props.children}
        </Styles>
    );
};

export default Layout;
